import { Reveal } from "./Reveal";

const FOCI = [
  "Conciencia",
  "Inteligencia emocional",
  "Patrones de pensamiento",
  "Sistema nervioso",
  "Integración",
  "Transformación personal",
];

export const Founder = () => (
  <section id="fundador" className="grain relative overflow-hidden bg-navy py-24 sm:py-32" data-testid="founder-section">
    <div className="container-luxe relative z-10">
      <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-3 rounded-sm border border-gold/20" />
              <div className="relative flex aspect-[3/4] w-full items-center justify-center overflow-hidden rounded-sm bg-navy-soft/40">
                <div className="text-center">
                  <span className="font-serif text-7xl text-gold/70">J.C.G.</span>
                  <span className="mt-4 block text-[0.6rem] uppercase tracking-luxe text-cream/50">
                    Fotografía oficial próximamente
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-navy/40 to-transparent" />
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal>
            <p className="overline mb-6 flex items-center gap-4">
              <span className="h-px w-10 bg-gold" /> El fundador
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif text-4xl font-light leading-[1.05] tracking-tight text-cream sm:text-5xl lg:text-6xl">
              José C. Guevara
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-3 font-serif text-xl italic text-gold">
              Fundador de la Academia Desde el Primer Latido™
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-xl text-base font-light leading-relaxed text-cream/70 sm:text-lg">
              Investigador y creador de programas centrados en la conciencia, la regulación
              emocional y el sistema nervioso, los patrones de pensamiento y la transformación
              personal. Su misión es acercar conocimientos profundos de una manera clara, práctica y
              accesible — para ayudar a las personas a comprender su historia, transformar sus
              patrones y desarrollar una vida más consciente.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-10 flex flex-wrap gap-3">
              {FOCI.map((f) => (
                <span
                  key={f}
                  className="rounded-full border border-gold/30 px-4 py-2 text-xs font-light text-cream/80"
                  data-testid={`founder-focus-${f}`}
                >
                  {f}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
